import type { DeviceData } from '../types';

export function withoutDevicePasscode(deviceData?: DeviceData): DeviceData | undefined {
  if (!deviceData) return undefined;

  const persistedDeviceData = { ...deviceData };
  delete persistedDeviceData.passcodeValue;
  return persistedDeviceData;
}